import "./LayoutWizardMetaItemListDialog.scss";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "LayoutWizardMetaItemListDialog",
  components: {},
  data: () => ({
    mainPeacock: "#00636C",
    mainRed: "#c55c52",
    isRequired: [v => !!v || "Feld bitte ausfüllen"],
    deleteList: []
  }),
  props: ["editedItems", "itemsGroup", "dialog", "config"],
  event: ["afterSave", "createError"],
  watch: {
    dialog(d) {
      //dialog open
      if (d) {
        this.unsaved = JSON.stringify(this.editedItem);
        this.deleteList = [];
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        try {
          success = await this.saveAll();
          if (success) {
            this.$emit("afterSave", close);
          }
        } catch (ex) {
          this.$emit("createError", ex);
        }
      } else {
        this.snackMessage(
          "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!",
          this.mainRed
        );
      }
    },
    snackMessage(...emitArgs) {
      //emit parent snackbar - child-snackbar seems unreliable
      this.$emit("snackMessage", ...emitArgs);
    },
    async saveItem(item) {
      if (!item._id) {
        this.createItem(item);
        return;
      }
      const headers = getTokenHeader();
      try {
        await axios.put(
          `${env.assistent_api_client_url}metadata/${item._id}`,
          item,
          { headers }
        );
      } catch (error) {
        this.createError(error);
      }
    },
    async createItem(item) {
      item.sort_key = this.editedItems.length + 1;
      const headers = getTokenHeader();
      item.principal_id = this.itemsGroup.principal_id;
      item.group_key = this.itemsGroup.key;
      try {
        const res = await axios.post(
          `${env.assistent_api_client_url}metadata/`,
          item,
          {
            headers
          }
        );
        this.editedItems.pop();
        this.editedItems.push(res.data);
      } catch (error) {
        this.createError(error);
      }
    },
    addToDeleteList(item) {
      if (item._id) {
        this.deleteList.push(item._id);
      }
      const itemIndex = this.editedItems.indexOf(item);
      this.editedItems.splice(itemIndex, 1);
    },
    async deleteItem(id) {
      const headers = getTokenHeader();
      try {
        await axios.delete(`${env.assistent_api_client_url}metadata/${id}`, {
          headers
        });
      } catch (error) {
        this.createError(error);
      }
    },
    addItemForm() {
      this.editedItems.push({ values: {} });
    },
    /**
     * move a element inside a array up or down
     * @param array
     * @param element
     * @param delta f.e. -1 to move up and 1 to move down
     */
    move(array, element, delta) {
      let index = array.indexOf(element); //find element to move
      let newIndex = index + delta; //calculate destination-index
      if (newIndex < 0 || newIndex === array.length) return; //Already at the top or bottom.
      let indexes = [index, newIndex].sort(); //Sort the indexes
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]); //Replace from lowest index, two elements, reverting the order
    },
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    async saveAll() {
      let count = 0;
      await this.editedItems.map(async item => {
        item.sort_key = count++;
        await this.saveItem(item);
      });
      await this.deleteList.asyncForEach(async id => {
        await this.deleteItem(id);
      });
      this.deleteList = [];
      return true;
    }
  }
};
